import React, { useCallback, useState, createContext, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Drawer } from "devextreme-react/drawer";
import "./navigationDrawer.css";
import NavigationList from "./navigationList";
import Dashboard from "../dashboard/dashboard";
import EditWidgets from "../edit-widgets/editWidgets";
export const DateContext = createContext();

function NavigationDrawer({ isOpened, setIsOpened }) {
  const renderList = useCallback(() => {
    return <NavigationList setIsOpened={setIsOpened} />;
  }, [isOpened]);

  /** DATE Variables */
  const dateRange = [
    {
      text: "Daily",
    },
    {
      text: "Weekly",
    },
    {
      text: "Monthly",
    },
    {
      text: "Yearly",
    },
  ];
  const currentDate = new Date();
  const startDateTime = new Date(currentDate);
  startDateTime.setHours(0, 0, 0, 0);
  const endDateTime = new Date(currentDate);
  const [startDate, setStartDate] = useState(startDateTime);
  const [endDate, setEndDate] = useState(endDateTime);
  const [selectedDate, setSelectedDate] = useState(dateRange[0]);

  return (
    <DateContext.Provider
      value={{
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        selectedDate,
        setSelectedDate,
      }}
    >
      <Drawer
        revealMode={"expand"}
        maxSize={150}
        openedStateMode={"push"}
        opened={isOpened}
        render={renderList}
      >
        <div id="routes-view">
          <Routes>
            <Route path="/" element={<Dashboard />}></Route>
            <Route path="/widgets" element={<EditWidgets />}></Route>
            <Route path="/roles" element={<Dashboard />}></Route>
          </Routes>
        </div>
      </Drawer>
    </DateContext.Provider>
  );
}

export default NavigationDrawer;
